import { apiRequest } from "./client";
import { api } from "./typed";
import type { components } from "./generated/backend";

export type SharedAssignmentResolved = components["schemas"]["SharedAssignmentResolved"];

export const sharedAssignmentsAPI = {
  /**
   * The assignment a share link leads to, for the signed-in user (#1072).
   * 404 for an unknown link, 410 once it has expired, been revoked or the
   * assignment is no longer open. The toast is suppressed: the login page
   * says so itself and carries on to the normal landing page.
   */
  resolve: (token: string): Promise<SharedAssignmentResolved> =>
    api.get("/shared-assignments/{token}/resolve", {
      path: { token },
      config: { suppressErrorToast: true },
    }),

  /**
   * Count one view on an invite share: the invited consultant opened the
   * invite email's link (#1089, backend#1032). 204, also when the share is
   * revoked, expired or closed; 404 when the signed-in user isn't the
   * recipient. A best-effort beacon, so the toast is suppressed.
   *
   * ⚠️ Escape hatch: the route is not in the generated schema yet. Move it to
   * the typed `api.post` once `backend.d.ts` is regenerated after backend#1032
   * merges.
   */
  reportInviteOpened: async (shareId: number): Promise<void> => {
    await apiRequest.post<void>(`/shared-assignments/invites/${shareId}/opened`, undefined, {
      suppressErrorToast: true,
    });
  },
};
